import { IconNameVariantType } from 'ui/components/Icon/Icon'

const SIZES = ['B', 'KB', 'MB', 'GB', 'TB']

export function formatBytes(bytes: number) {
    if (bytes === 0) return '0 B'

    const i = Math.floor(Math.log(bytes) / Math.log(1024))

    return `${(bytes / 1024 ** i).toFixed(i ? 1 : 0)} ${SIZES[i]}`
}

export function isFileImage(file: File) {
    return file.type.startsWith('image/')
}

export function getFileExtension(file: File) {
    return file.name.split('.').pop()?.toLowerCase() ?? ''
}

const TEXT_EXTENSIONS = new Set(['txt', 'md', 'rtf', 'pdf'])
const ARCHIVE_EXTENSIONS = new Set(['zip', 'rar', '7z', 'tar', 'gz', 'bz2'])

export function getFileIcon(file: File): IconNameVariantType<'lucide'> {
    const type = file.type
    const extension = getFileExtension(file)

    if (type.startsWith('video/')) {
        return { name: 'FileVideo' }
    }

    if (type.startsWith('audio/')) {
        return { name: 'FileAudio' }
    }

    if (type.startsWith('text/') || TEXT_EXTENSIONS.has(extension)) {
        return { name: 'FileText' }
    }

    if (ARCHIVE_EXTENSIONS.has(extension)) {
        return { name: 'FileArchive' }
    }

    return { name: 'File' }
}

const MATCH_ALL_GLOB = '/*'

export function validateFile(file: File, accept?: string, maxSize?: number): [boolean, string] {
    const acceptTypes = accept?.split(',').map((t) => t.trim()) ?? null

    if (acceptTypes) {
        const fileType = file.type
        const fileExtension = `.${getFileExtension(file)}`

        if (
            !acceptTypes.some((type) => {
                if (type === fileType) return true
                if (type === fileExtension) return true
                if (
                    type.includes(MATCH_ALL_GLOB) &&
                    fileType.startsWith(type.replace(MATCH_ALL_GLOB, '/'))
                ) {
                    return true
                }

                return false
            })
        ) {
            return [false, 'File type not accepted.']
        }
    }

    if (maxSize && file.size > maxSize) {
        return [false, 'File too large.']
    }

    return [true, '']
}

export function getFilestackPath(
    selectedStack?: StackDto | null,
    workspaceAccount?: Account | null
) {
    if (!workspaceAccount || !selectedStack) {
        return undefined
    }

    return selectedStack
        ? `/astra/${workspaceAccount?._sid}/${selectedStack._sid}/`
        : `/astra/${workspaceAccount?._sid}/`
}

export function formatFileCount(count: number) {
    if (count === 1) {
        return '1 file'
    }

    return `${count} files`
}
